import TarotApp from './TarotApp.jsx';

/**
 * 路由层只负责把独立塔罗组件挂进来，不附加任何 chrome —— 让塔罗自带的设计完整呈现。
 * 外层 app-shell 会负责底部 tabbar 的留空。
 */
export default function TarotPage() {
  return <TarotApp />;
}
